import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import user from "../../../img/dum.webp";
import { useDispatch } from "react-redux";
import { userView } from "../../../Helper/Redux/API";
import { toast } from "react-toastify";
function TopHeader(props) {
  const history = useNavigate();
  const dispatch = useDispatch();

  const access_token = localStorage.getItem("access_token");
  const UserName = localStorage.getItem("UserName");
  const LastName = localStorage.getItem("lastName");
  const { pathname } = useLocation();
  const logout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("UserName");
    localStorage.removeItem("lastName");
    localStorage.removeItem("Roleid");
    localStorage.removeItem("id");
    localStorage.removeItem("step2");
    localStorage.removeItem("step3");
    localStorage.removeItem("step4");
    localStorage.removeItem("step5");
    localStorage.removeItem("step6");
    localStorage.removeItem("step7");
    localStorage.removeItem("step8");
    localStorage.removeItem("step9");
    localStorage.removeItem("Rightear2KHz");
    localStorage.removeItem("Rightear4KHz");
    localStorage.removeItem("Leftear1KHz");
    localStorage.removeItem("Leftear6KHz");
    localStorage.removeItem("Measuretest");
    localStorage.removeItem("result_test_id");
    localStorage.removeItem("Rightear500Hz");
    localStorage.removeItem("rightear1KHz");
    localStorage.removeItem("Leftear500Hz");
    localStorage.removeItem("Leftear2000KHz");
    localStorage.removeItem("UserName");
    localStorage.removeItem("LastName");
    // localStorage.removeItem("testtrue");

    history("/");
  };
  const [intintialValue, setInitialValue] = useState({
    name: "",
    image: "",
  });

  const getviewuser = () => {
    const data = {
      id: localStorage.getItem("id"),
    };
    try {
      dispatch(userView(data)).then((res) => {
        if (res?.payload?.status === true) {
          setInitialValue({
            name: `${res?.payload?.data.first_name} ${
              res?.payload?.data.last_name ? res?.payload?.data.last_name : ""
            }`,
            image: res?.payload?.data.media[0]?.original_url,
          });
        }

        if (res?.payload?.is_active == false) {
          toast.error(res?.payload?.message);
          logout();
        }
      });
    } catch (error) {
      console.log(error, "error");
    }
  };

  useEffect(() => {
    getviewuser();
  }, []);
  return (
    <>
      <section className="top_head sticky-top">
        <div className="container-fluid">
          <div className="top_bar_section row align-items-center">
            <div className="col-9">
              <div className="heaing_test">
                <h1>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    height="30"
                    viewBox="0 0 30 30"
                    fill="none"
                  >
                    <path
                      d="M17.245 5.17014C16.017 3.90187 13.9829 3.90186 12.7549 5.17013L6.75682 11.3648C6.41234 11.7206 6.18086 12.1703 6.09154 12.6574C5.36309 16.6299 5.30932 20.6967 5.93249 24.687L6.15311 26.0998C6.2228 26.546 6.60713 26.875 7.05876 26.875H11.25C11.5951 26.875 11.875 26.5952 11.875 26.25V17.5H18.125V26.25C18.125 26.5952 18.4048 26.875 18.75 26.875H22.9411C23.3927 26.875 23.7771 26.546 23.8468 26.0998L24.0674 24.687C24.6905 20.6967 24.6368 16.6299 23.9083 12.6574C23.819 12.1703 23.5875 11.7206 23.2431 11.3648L17.245 5.17014Z"
                      fill="#33a47f"
                    />
                  </svg>

                  {props.heding_text}
                </h1>
                <Link
                  className="nav-link"
                  aria-current="page"
                  // target="_blank"
                  to="/Heartest"
                >
                  <button className="btn">Online Hearing test</button>
                </Link>{" "}
                {/* <div className="Whatshap whtshdata">
                  <a href="https://wa.me/6597767615" target="_blank">
                    <i class="fa fa-whatsapp" aria-hidden="true"></i> 
                  </a>
                </div> */}
                <div class="header_whatsap_btn "><a href="https://wa.me/6597767615" target="_blank"><i class="fa fa-whatsapp" aria-hidden="true"></i>&nbsp;&nbsp;<span> Book Appointment on WhatsApp </span></a></div>
              </div>
            </div>

            <div className="col-3">
              <div class="dropdown">
                <button
                  class="btn btn-secondary dropdown-toggle"
                  type="button"
                  id="Top_header"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <div className="avatarName d-none d-md-inline-block">
                    {UserName ? UserName : ""}&nbsp;
                    {LastName ? LastName : ""} &nbsp;&nbsp;
                  </div>
                  <img
                    src={intintialValue?.image ? intintialValue?.image : user}
                    className="img-fluid profile"
                    alt="user_img"
                  />
                </button>
                <ul class="dropdown-menu" aria-labelledby="Top_header">
                  <li>
                    <a class="dropdown-item" onClick={logout}>
                      Logout
                    </a>
                  </li>
                </ul>
              </div>
              {/* <ul>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <path
                      d="M10.875 12C10.875 12.2984 10.9935 12.5845 11.2045 12.7955C11.4155 13.0065 11.7016 13.125 12 13.125C12.2984 13.125 12.5845 13.0065 12.7955 12.7955C13.0065 12.5845 13.125 12.2984 13.125 12C13.125 11.7016 13.0065 11.4155 12.7955 11.2045C12.5845 10.9935 12.2984 10.875 12 10.875C11.7016 10.875 11.4155 10.9935 11.2045 11.2045C10.9935 11.4155 10.875 11.7016 10.875 12ZM15.5625 12C15.5625 12.2984 15.681 12.5845 15.892 12.7955C16.103 13.0065 16.3891 13.125 16.6875 13.125C16.9859 13.125 17.272 13.0065 17.483 12.7955C17.694 12.5845 17.8125 12.2984 17.8125 12C17.8125 11.7016 17.694 11.4155 17.483 11.2045C17.272 10.9935 16.9859 10.875 16.6875 10.875C16.3891 10.875 16.103 10.9935 15.892 11.2045C15.681 11.4155 15.5625 11.7016 15.5625 12ZM6.18751 12C6.18751 12.2984 6.30604 12.5845 6.51702 12.7955C6.72799 13.0065 7.01414 13.125 7.31251 13.125C7.61088 13.125 7.89703 13.0065 8.10801 12.7955C8.31898 12.5845 8.43751 12.2984 8.43751 12C8.43751 11.7016 8.31898 11.4155 8.10801 11.2045C7.89703 10.9935 7.61088 10.875 7.31251 10.875C7.01414 10.875 6.72799 10.9935 6.51702 11.2045C6.30604 11.4155 6.18751 11.7016 6.18751 12ZM21.6844 7.93125C21.1547 6.67266 20.3953 5.54297 19.4274 4.57266C18.4662 3.60796 17.3251 2.84114 16.0688 2.31563C14.7797 1.77422 13.4109 1.5 12 1.5H11.9531C10.5328 1.50703 9.15704 1.78828 7.86329 2.34141C6.61772 2.87232 5.48735 3.64049 4.53517 4.60312C3.57657 5.57109 2.82423 6.69609 2.30392 7.95C1.76485 9.24844 1.49298 10.6289 1.50001 12.0492C1.50796 13.6769 1.89304 15.2806 2.62501 16.7344V20.2969C2.62501 20.5828 2.7386 20.857 2.94079 21.0592C3.14297 21.2614 3.4172 21.375 3.70314 21.375H7.26798C8.72179 22.107 10.3255 22.492 11.9531 22.5H12.0024C13.4063 22.5 14.768 22.2281 16.05 21.6961C17.3 21.1768 18.4368 20.419 19.3969 19.4648C20.3649 18.5063 21.1266 17.3859 21.6586 16.1367C22.2117 14.843 22.493 13.4672 22.5 12.0469C22.507 10.6195 22.2305 9.23438 21.6844 7.93125ZM18.143 18.1969C16.5 19.8234 14.3203 20.7188 12 20.7188H11.9602C10.5469 20.7117 9.14298 20.3602 7.90314 19.6992L7.70626 19.5938H4.40626V16.2938L4.30079 16.0969C3.63985 14.857 3.28829 13.4531 3.28126 12.0398C3.27189 9.70312 4.16485 7.50937 5.80314 5.85703C7.43907 4.20469 9.62579 3.29062 11.9625 3.28125H12.0024C13.1742 3.28125 14.3109 3.50859 15.382 3.95859C16.4274 4.39687 17.3649 5.02734 18.1711 5.83359C18.975 6.6375 19.6078 7.57734 20.0461 8.62266C20.5008 9.70547 20.7281 10.8539 20.7234 12.0398C20.7094 14.3742 19.793 16.5609 18.143 18.1969Z"
                      fill="#363954"
                    />
                  </svg>
                </li>
                <li>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                  >
                    <g clip-path="url(#clip0_317_141)">
                      <path
                        d="M12 22.8533C12.4199 22.8437 12.8229 22.6858 13.1377 22.4076C13.4525 22.1295 13.6587 21.7489 13.72 21.3333H10.2133C10.2763 21.7602 10.4922 22.1497 10.8209 22.4293C11.1495 22.7089 11.5685 22.8596 12 22.8533Z"
                        fill="#363954"
                      />
                      <path
                        d="M21.6733 18.5533C21.0305 17.9802 20.4676 17.3232 20 16.6C19.4895 15.6017 19.1835 14.5115 19.1 13.3933V10.1C19.0973 9.69995 19.0616 9.30082 18.9933 8.90665C18.4686 8.80176 17.9643 8.61265 17.5 8.34665C17.677 8.91655 17.7669 9.50991 17.7667 10.1067V13.4C17.8484 14.764 18.2236 16.0943 18.8667 17.3C19.3269 18.0293 19.8731 18.7008 20.4933 19.3H3.41999C4.04026 18.7008 4.58639 18.0293 5.04666 17.3C5.68973 16.0943 6.06495 14.764 6.14666 13.4V10.1C6.14315 9.32844 6.29186 8.56379 6.58429 7.8498C6.87671 7.13581 7.3071 6.48652 7.8508 5.93909C8.39451 5.39167 9.04086 4.95687 9.75284 4.65959C10.4648 4.36232 11.2284 4.2084 12 4.20665C13.1292 4.20756 14.233 4.54149 15.1733 5.16665C15.0697 4.78598 15.0115 4.39436 15 3.99999V3.57999C14.3039 3.23756 13.5561 3.01231 12.7867 2.91332V2.07332C12.7867 1.83728 12.6929 1.6109 12.526 1.44399C12.3591 1.27709 12.1327 1.18332 11.8967 1.18332C11.6606 1.18332 11.4342 1.27709 11.2673 1.44399C11.1004 1.6109 11.0067 1.83728 11.0067 2.07332V2.94665C9.2838 3.18969 7.70704 4.04782 6.56747 5.36261C5.4279 6.6774 4.80248 8.36008 4.80666 10.1V13.3933C4.72316 14.5115 4.41718 15.6017 3.90666 16.6C3.44725 17.3216 2.89346 17.9785 2.25999 18.5533C2.18888 18.6158 2.13189 18.6927 2.0928 18.7789C2.05372 18.8651 2.03345 18.9587 2.03333 19.0533V19.96C2.03333 20.1368 2.10356 20.3064 2.22859 20.4314C2.35361 20.5564 2.52318 20.6267 2.69999 20.6267H21.2333C21.4101 20.6267 21.5797 20.5564 21.7047 20.4314C21.8298 20.3064 21.9 20.1368 21.9 19.96V19.0533C21.8999 18.9587 21.8796 18.8651 21.8405 18.7789C21.8014 18.6927 21.7444 18.6158 21.6733 18.5533Z"
                        fill="#363954"
                      />
                      <path
                        d="M20 7.33332C21.841 7.33332 23.3334 5.84094 23.3334 3.99999C23.3334 2.15904 21.841 0.666656 20 0.666656C18.1591 0.666656 16.6667 2.15904 16.6667 3.99999C16.6667 5.84094 18.1591 7.33332 20 7.33332Z"
                        fill="#FF3D3D"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_317_141">
                        <rect width="24" height="24" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </li>
              </ul> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default TopHeader;
